"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ArrowRightIcon = ({ className, width = '40', height = '40', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { role: "img", width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "currentColor", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M3.75 10L16.25 10M16.25 10L10.625 4.375M16.25 10L10.625 15.625", stroke: "#151C23", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
exports.default = ArrowRightIcon;
//# sourceMappingURL=ArrowRightIcon.js.map